export default {
  ADD_COUPON (state, coupon) {
    state.coupons.unshift(coupon)
  },
  SET_COUPON (state, coupons) {
    state.coupons = coupons
  },
  UPDATE_COUPON (state, coupon) {
    const couponIndex = state.coupons.findIndex((p) => p._id === coupon._id)
    Object.assign(state.coupons[couponIndex], coupon)
  },
  REMOVE_COUPON (state, couponId) {
    const couponIndex = state.coupons.findIndex((p) => p._id === couponId)
    state.coupons.splice(couponIndex, 1)
  },
  SET_PRODUCTINFO (state, productList) {
    state.productList = productList
  },
  SET_USERINFO (state, userList) {
    state.userList = userList
  }
}
  